import { useContext } from 'react';
import UserPlanContext, { IUserPlanContext } from 'dashboard/contexts/UserPlanContext';

const useStats = (): IUserPlanContext => useContext(UserPlanContext);

export default useStats;
